import { render, staticRenderFns } from "./InvoicingItemsTable.vue?vue&type=template&id=56322580&"
import script from "./InvoicingItemsTable.vue?vue&type=script&lang=js&"
export * from "./InvoicingItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicingItemsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports